var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VerifiedAccount50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M44,24c0-2.909-1.653-5.448-4.066-6.73c0.659-2.511,0.017-5.303-1.943-7.262 C36.528,8.544,34.6,7.816,32.67,7.816c-0.653,0-1.306,0.083-1.941,0.25C29.448,5.653,26.909,4,24,4s-5.448,1.653-6.73,4.066 c-0.636-0.167-1.288-0.25-1.941-0.25c-1.93,0-3.857,0.729-5.321,2.192c-1.959,1.959-2.602,4.75-1.943,7.262 C5.653,18.552,4,21.091,4,24s1.653,5.448,4.066,6.73c-0.659,2.511-0.017,5.303,1.943,7.262c1.463,1.463,3.391,2.192,5.321,2.192 c0.653,0,1.306-0.083,1.941-0.25C18.552,42.347,21.091,44,24,44s5.448-1.653,6.73-4.066c0.636,0.167,1.288,0.25,1.941,0.25 c1.93,0,3.857-0.729,5.321-2.192c1.959-1.959,2.602-4.75,1.943-7.262C42.347,29.448,44,26.909,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 32.829L14.586 25.414 17.414 22.586 22 27.171 31.586 17.586 34.414 20.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VerifiedAccount50);
export default __webpack_public_path__ + "static/media/icons8-verified-account-50.c0410f3b8edd2d9f93441904cadf6f6c.svg";
export { ForwardRef as ReactComponent };